// src/config/clover.js

/**
 * Application configuration
 * Centralizes access to environment variables
 */

// Configuration object
const config = {
  // Clover API configuration
  clover: {
    // API URL
    apiUrl:
      import.meta.env.VITE_CLOVER_ENV === 'dev'
        ? import.meta.env.VITE_CLOVER_API_DEV_URL
        : import.meta.env.VITE_CLOVER_API_URL,
    // Merchant ID
    merchantId:
      import.meta.env.VITE_CLOVER_ENV === 'dev'
        ? import.meta.env.VITE_CLOVER_DEV_MERCHANT_ID
        : import.meta.env.VITE_CLOVER_MERCHANT_ID,
    // API key
    apiKey:
      import.meta.env.VITE_CLOVER_ENV === 'dev'
        ? import.meta.env.VITE_CLOVER_DEV_API_KEY
        : import.meta.env.VITE_CLOVER_API_KEY,
    // Request timeout in milliseconds
    requestTimeout: 10000,
    // Menu refresh URL (Netlify function)
    refreshUrl: '/.netlify/functions/refresh-from-clover',
  },

  // Application settings
  app: {
    debug: import.meta.env.MODE === 'development',
    useLocalDataFallback: true,
    retryAttempts: 2,
    retryDelay: 1000,
  },
};

// Always log Clover environment for developer reassurance
// eslint-disable-next-line no-console
console.log(
  '🔒 [CLOVER API]',
  import.meta.env.VITE_CLOVER_ENV === 'dev'
    ? '🟡 DEVELOPMENT'
    : '🟢 PRODUCTION',
  '| Merchant:',
  config.clover.merchantId
    ? '...' + config.clover.merchantId.substr(-4)
    : 'unknown',
);

export default config;
